import React, { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import { Link } from "react-router-dom";
import { UploadIcon, EditIcon } from "../../../assets/icons/Icons";
import DateRangeFilter from "../../../components/filters/DateRangeFilter";
import { FilterContextProvider } from "../../../contexts/FilterContext";
import EditCardholder from "../../../components/cardholder/Edit";
import BulkCreateCards from "../../../components/cardholder/bulk-create/BulkCreateCards";
import Popup from "../../../components/Popup";
import ExportDataButton from "../../../components/ExportDataButton";
import ResetFilters from "../../../components/filters/ResetFilters";
import { useUserContext } from "../../../contexts/UserContext";
import DataTable from "../../../components/DataTable";
import useData from "../../../hooks/useData";
// import FilterReports from "../../../api/reports/filterReports";
// import { DeleteReport } from "../../../api/reports/deleteReport";
import FilterCardholders from "../../../api/cardholders/FilterCardholders";
import useExportCSV from "../../../hooks/useExportCSV";
import { formatDate } from "../../../utils/formatDate";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../../../components/CustomTooltip";
import { useGlobalContext } from "../../../contexts/GlobalContext";

function Index(props) {
  const { t } = useTranslation();
  // eslint-disable-next-line
  const [newCardHoldersUploaded, setNewCardHoldersUploaded] = useState(false);
  const [showBulkCreateCards, setShowBulkCreateCards] = useState(false);

  const { can: userCan } = useUserContext();

  const {
    data,
    errorMessage,
    loadingData,
    pageCount,
    selectedItem,
    setSelectedItem,
    showEditItem,
    setShowEditItem,
  } = useData(FilterCardholders);

  const { handleExportCSV } = useExportCSV(FilterCardholders, "cardholders");

  const { setPageTitle, setBreadcrumbs } = useGlobalContext();

  useEffect(() => {
    setPageTitle(t("Card Issuing"));
    setBreadcrumbs([t("Card Issuing"), t("Cardholders")]);

    return () => {
      setPageTitle("");
      setBreadcrumbs([]);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Layout title={t("Cardholders")} breadcrumbs={t("Card Issuing")}>
      {showBulkCreateCards && (
        <Popup
          size="extra-large"
          withClose
          withOverlay
          onClose={() => setShowBulkCreateCards(false)}
        >
          <BulkCreateCards
            setNewCardHoldersUploaded={setNewCardHoldersUploaded}
            setShowBulkCreateCards={setShowBulkCreateCards}
          />
        </Popup>
      )}

      {showEditItem && (
        <Popup
          size="large"
          withClose
          withOverlay
          onClose={() => setShowEditItem(false)}
        >
          <EditCardholder cardholder={selectedItem} />
        </Popup>
      )}

      <DataTable
        filtersTop={
          <>
            <FilterContextProvider name="date">
              <DateRangeFilter />
            </FilterContextProvider>
            <FilterContextProvider>
              <ResetFilters />
            </FilterContextProvider>
          </>
        }
        buttons={
          <>
            <ExportDataButton
              className="btn btn-secondary btn-medium"
              onClick={handleExportCSV}
              label={t("Export CSV")}
            />

            {userCan("cardholder", "write") && (
              <button
                onClick={(e) => setShowBulkCreateCards(true)}
                className="btn btn-primary btn-medium"
              >
                <UploadIcon />
                {t("Bulk Create Cards")}
              </button>
            )}
          </>
        }
        columns={[
          { header: t("User ID"), accessor: "id" },
          { header: t("User Name"), accessor: "username" },
          {
            header: t("Processor Reference"),
            accessor: "primary_processor_reference",
          },
          { header: t("External Tag"), accessor: "external_tag" },
          { header: t("Created on"), accessor: "created_at" },
          { header: t("Action"), accessor: "actions" },
        ]}
        rows={data.data || []}
        pageCount={pageCount}
        loadingData={loadingData}
        error={errorMessage}
        actions={(item) => (
          <div className="d-flex align-items-center">
            <Link
              to="#"
              className="edit-link"
              onClick={(e) => {
                e.preventDefault();
                setSelectedItem(item);
                setShowEditItem(true);
              }}
            >
              <CustomTooltip icon={<EditIcon />} message={t("Edit")} />
            </Link>
          </div>
        )}
        customOutputs={(columnName, value) => {
          switch (columnName) {
            case "created_at":
              return formatDate(value);
            default:
              return value;
          }
        }}
      />
    </Layout>
  );
}

export default Index;
